import { Contract } from "appworks/utils/contracts/contract";
import { LandPulseSymbolBehaviour } from "./land-pulse-symbol-behaviour";

export class AnticipateLandPulseSymbolBehaviour extends LandPulseSymbolBehaviour {
    public static ANIMATION_DURATION: number = 200;

    public static ZOOM_TO: number = 1.1;

    public behaviourName: string = "AnticipateLandPulse";

    public anticipateLand(): Contract<void> {
        return super.land();
    }

    public land() {
        return Contract.empty();
    }
}
